
export enum LaunchEvent {
    Init = 'launch_init',//初始化,启动游戏
    FirstScene = 'launch_first_scene',//启动,进入第一场景
    Loading = 'launch_loading',//启动,开始加载
    LoadComplete = 'launch_load_complete',//加载完成
    LoginScene = 'launch_login_scene',//登录页面
    SDKInit = 'launch_sdk_init',//sdk初始化
    SDKLogin = 'launch_sdk_login',//sdk登录
    RequestGateWay = 'launch_request_gateway',//加载网关
    RequestGateWayComplete = 'launch_request_gateway_complete',//加载网关完成
    RequestServerList = 'launch_request_server_list',//加载服务器列表
    RequestServerListComplete = 'launch_request_server_list_complete',//加载服务器列表完成
    RequestWhiteList = 'launch_request_white_list',//加载白名单
    RequestWhiteListComplete = 'launch_request_white_list_complete',//加载白名单完成
    ShowNotice = 'launch_show_notice',//显示公告
    CloseNotice = 'launch_close_notice',//关闭公告
    ClickEnter = 'launch_click_enter',//点击登录按钮
    Subscribe = 'launch_subscribe',//订阅消息
    SubscribeComplete = 'launch_subscribe_complete',//订阅消息完成
    Config = 'launch_config',//加载config
    ConfigComplete = 'launch_config_complete',//配置完成
    Prefab = 'launch_prefab',//加载预制体
    PrefabComplete = 'launch_prefab_complete',//预制体加载完成
    Connected = 'launch_connected',//连接成功
    LoginError = 'launch_login_error',//登录失败
    LoginSuccess = 'launch_login_success',//登录成功
    EnterGame = 'launch_enter_game',//进入游戏
    HomeCity = 'launch_home_city',//进入主城
}


/*
 * 数数科技数据统计API 
 * https://docs-v2.thinkingdata.cn/?version=latest&lan=zh-CN&code=mp_sdk_installation&anchorId=
 */
export class ThinkingAnalyticsController {
    private static _instance: ThinkingAnalyticsController

    public static get ins(): ThinkingAnalyticsController {
        if (ThinkingAnalyticsController._instance == null)
            ThinkingAnalyticsController._instance = new ThinkingAnalyticsController()
        return ThinkingAnalyticsController._instance
    }

    //@ts-ignore
    private _ta: any = null//TDAnalytics

    //初始化sdk
    init() {
        if (window['wx']) {
            let GlobalTA = window['wx']['_GlobalTA']
            if (GlobalTA) {
                //已经初始化好了，就用这个吧
                this._ta = GlobalTA
                return;
            }
        }
        // TA SDK 配置对象
        var config = {
            appId: CC_DEV ? "debug-appid" : "64d01dd929bf4e7f9ec2b392a342789a", // 项目 APP ID
            serverUrl: "https://log.shalougame.com:8991", // 上报地址
            enableLog: false,
            autoTrack: {
                appShow: true, // 自动采集 ta_mg_show
                appHide: true // 自动采集 ta_mg_hide
            }
        };

        // 创建 TA 实例
        //@ts-ignore
        this._ta = TDAnalytics

        // 初始化
        TDAnalytics.init(config);

        // 上报一个简单事件, 事件名为 test_event
        this.launchEvent(LaunchEvent.Init, {})
    }
    getDistinctId() {
        if (this._ta)
            return this._ta.getDistinctId()
        return '0000'
    }
    track(eventName: string, param: any) {
        if (this._ta) {
            this._ta.track({
                eventName: eventName, // 事件名称
                properties: param ? param : {}, // 事件属性
            });
            cc.log(eventName, param)
        }
    }

    launchEvent(eventName: LaunchEvent, param: any) {
        if (this._ta) {
            this.track(eventName, param);
        }
    }

    //设置账号，方便统计
    setAccount(param: string) {
        if (this._ta)
            this._ta.login(param)
    }



};

